import { RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_NG, RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_OK, } from '@/utils/constants/rfp/isOpenExperiencedIndustryClassName';
/**
 * 案件の業界名開示状態に応じたテキストを返す
 * @param options
 */
export const getExperiencedIndustryClassName = (options) => {
    const { discloseText = RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_NG.label, experiencedIndustryClassName, isOpenExperiencedIndustryClass, } = options;
    // 開示状態に応じて表示するテキストを切り替える
    return isOpenExperiencedIndustryClass ===
        RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_OK.value
        ? experiencedIndustryClassName
        : discloseText;
};
